// START Hide Empty accordians - collapsible rows
setTimeout(() => {
   var buttons = document.querySelectorAll('.product__accordion.accordion ')
buttons.forEach(b => {
    var content = b.querySelectorAll('.accordion__content.rte')
    content.forEach(child => {
        if(child.childElementCount ==0){
            b.style.display =  'none'
          console.log(child.childElementCount)
        }
    })
               
}
)
},1000)
// END Hide Empty accordians - collapsible rows

// START Hide Empty accordians - collapsible rows
setTimeout(() => {
   var buttons = document.querySelectorAll('.accordion ')
buttons.forEach(b => {
    var content = b.querySelectorAll('.accordion__content.rte')
    content.forEach(child => {
        if(child.childElementCount == 0){
            b.style.display =  'none'
        }
    })
               
}
)
},1000)

// END Hide Empty accordians - collapsible rows

// START Change logo for mobile
//if($(window).width() < 568) {
//   console.log($(window).width());
//    $(".header__heading-logo").each(function() {
//      
//      $(this).attr("src", "https://cdn.shopify.com/s/files/1/0729/2210/4107/files/VFC_2026-script-logo-website_20260605.svg?v=1781026782"); 
//      $(this).attr("srcset", "https://cdn.shopify.com/s/files/1/0729/2210/4107/files/VFC_2026-script-logo-website_20260605.svg?v=1781026782"); 
//                });
//            } else if ($(window).width() >= 568) {
//                
//                $(".header__heading-logo").each(function() {
//                $(this).attr("src","https://cdn.shopify.com/s/files/1/0729/2210/4107/files/VFC_2026-script-logo-website_20260605.svg?v=1781026782");
//                $(this).attr("srcset","https://cdn.shopify.com/s/files/1/0729/2210/4107/files/VFC_2026-script-logo-website_20260605.svg?v=1781026782");
//                $(this).attr("width","350");
//                });                        
//    };
// END Change logo for mobile

// START Change main banner size for mobile
if($(window).width() < 568) {
   console.log($(window).width());
    $("#Slider-template--22967978000683__custom_slideshow_mQa3TC").each(function() {
      
      $(this).removeClass(".slideshow banner banner--adapt_image grid grid--1-col slider slider--everywhere scroll-trigger animate--fade-in"); 
      $(this).addClass(".slideshow banner banner--large grid grid--1-col slider slider--everywhere scroll-trigger animate--fade-in");
                });                      
    };
// END Change main banner size for mobile

//Add image to gift menu
//$("#HeaderMenu-gift-guide > span").prepend("<img src='https://cdn.shopify.com/s/files/1/0729/2210/4107/files/gift_icon_5b0ec07a-1b82-4858-a36c-dfc8bc6c1cee.png?v=1732050944' style='max-width: 20px; margin-right: 4px; position: absolute; padding-top: 3px; left: -1px;'>");  
// console.log("nav-gift-img-load");
//END add image to gift menu


// START Move Product Description
//$(document).ready(function() {
//  $('.product__description').appendTo('#Product-Description');
//});
// END Move Product Description

// Code that controls product images for variants is in global.js line 963 and 1040-1050 - NOT SURE WHAT THIS IS ANYMORE



